import { PAGEINFO } from 'App/store/constants';

interface PageInfoState {
    pageinfo: any | null;
    errors: any;
    loading: boolean;
    notFound: boolean;
    cache: Record<string, { data: any; ts: number }>;
}

const initialState: PageInfoState = {
    pageinfo: null,
    errors: {},
    loading: false,
    notFound: false,
    cache: {},
};

const reducer = (state: PageInfoState = initialState, action: any): PageInfoState => {
    switch (action.type) {
        case PAGEINFO.PENDING: {
            const alias = action.payload && action.payload.alias;
            // If we already have this alias cached and it's fresh, surface it
            // immediately so the UI doesn't flash a spinner on every navigation.
            const cached = alias ? state.cache[alias] : null;
            if (cached && Date.now() - cached.ts < 5 * 60 * 1000) {
                return {
                    ...state,
                    pageinfo: cached.data,
                    loading: false,
                    notFound: false,
                    errors: {},
                };
            }
            return { ...state, pageinfo: null, loading: true, notFound: false, errors: {} };
        }
        case PAGEINFO.SUCCESS: {
            const data = action.payload && action.payload.data;
            const alias = data && data.alias_name;
            const nextCache = alias
                ? { ...state.cache, [alias]: { data, ts: Date.now() } }
                : state.cache;
            return { ...state, pageinfo: data || null, loading: false, notFound: !data, cache: nextCache };
        }
        case PAGEINFO.FAILURE: {
            const status = action.status;
            return {
                ...state,
                pageinfo: null,
                loading: false,
                notFound: status === 404,
                errors: action.payload,
            };
        }
        default:
            return state;
    }
};

export default reducer;
